import { render, staticRenderFns } from "./LeadOnBoard.vue?vue&type=template&id=9cb07bb8&scoped=true&"
import script from "./LeadOnBoard.vue?vue&type=script&lang=js&"
export * from "./LeadOnBoard.vue?vue&type=script&lang=js&"
import style0 from "./LeadOnBoard.vue?vue&type=style&index=0&id=9cb07bb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb07bb8",
  null
  
)

export default component.exports